/**
 * Schlupfwespen List-View Selector + Kartenrechner
 * Loaded as asset, runs on pages with .sw__list
 *
 * PageSpeed notes:
 * - Item card-data (karten count, price, total) pre-computed ONCE at init.
 *   Previously: querySelector x3 + regex.match PER item PER calc() call.
 *   For 10 items with 3 calc invocations that's 90 DOM queries + 30 regex
 *   evaluations. Now: 30 queries + 10 regex at init, 0 afterwards.
 * - .kr__s step-panels cached once (was: querySelectorAll on every goS()).
 * - Result-area element refs cached once (was: getElementById x5 per calc).
 */
(function() {
  var items = document.querySelectorAll('.sw__item');
  if (!items.length) return;

  var hiddenSel = document.querySelector('select.variant-selection__variants');

  /* Hide old swatches */
  var oldSwatches = document.querySelectorAll(
    '.variant-selection,fieldset.custom-swatches,.swatches-header,[class*="options-selection__swatches"]'
  );
  for (var i = 0; i < oldSwatches.length; i++) {
    oldSwatches[i].style.setProperty('display', 'none', 'important');
  }

  /* === LIST VIEW: Variant Selection === */
  items.forEach(function(it) {
    it.addEventListener('click', function() {
      var vid = this.dataset.vid;
      var r = this.querySelector('.sw__radio');
      if (r && r.disabled) return;

      items.forEach(function(i) { i.classList.remove('sw__item--on'); });
      this.classList.add('sw__item--on');
      if (r) r.checked = true;

      /* Sync hidden select */
      if (hiddenSel) {
        for (var j = 0; j < hiddenSel.options.length; j++) {
          if (hiddenSel.options[j].value == vid) {
            hiddenSel.selectedIndex = j;
            hiddenSel.dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
      }

      /* Input[name=id] */
      var inp = document.querySelector('input[name="id"]');
      if (inp) inp.value = vid;

      /* URL */
      var u = new URL(window.location);
      u.searchParams.set('variant', vid);
      history.replaceState(null, '', u.toString());
    });
  });

  /* === KARTENRECHNER MODAL === */
  var modal = document.getElementById('kr-modal');
  if (!modal) return;

  /* Cached references — used by goS() and calc() on every step */
  var stepPanels = document.querySelectorAll('.kr__s');
  var resultRefs = {
    rk: document.getElementById('kr-rk'),
    rd: document.getElementById('kr-rd'),
    rp: document.getElementById('kr-rp'),
    rpc: document.getElementById('kr-rpc'),
    rw: document.getElementById('kr-rw'),
  };
  var sub2El = document.getElementById('kr-2s');
  var bf = document.getElementById('kr-bf');
  var state = {};
  var pcts = { '1': '0', '2': '33%', '3': '66%', 'r': '100%' };

  /**
   * Pre-parse each item card's data ONCE at init. Each variant card exposes:
   *   .sw__karten = card count per delivery (text)
   *   .sw__price  = price label
   *   .sw__detail = free text, may contain "N Karten gesamt"
   * We snapshot numeric values so calc() is a pure array scan — no DOM/regex work.
   */
  var cardData = [];
  var TOTAL_RX = /(\d+)\s*Karten gesamt/;
  items.forEach(function(it) {
    var k = it.querySelector('.sw__karten');
    if (!k) return;
    var p = it.querySelector('.sw__price');
    var d = it.querySelector('.sw__detail');
    var kp = parseInt(k.textContent, 10);
    var totalMatch = d ? d.textContent.match(TOTAL_RX) : null;
    // `total` falls back to kp*lief; we store per-delivery kp and the match result
    // and compute final total inside calc() only if no explicit "N Karten gesamt" text.
    cardData.push({
      kp: kp,
      totalExplicit: totalMatch ? parseInt(totalMatch[1], 10) : null,
      el: it,
      priceText: p ? p.textContent.trim() : '',
    });
  });

  function openKR() {
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    state = {};
    goS('1');
  }
  function closeKR() {
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  function goS(s) {
    for (var i = 0; i < stepPanels.length; i++) {
      stepPanels[i].classList.remove('kr__s--on');
    }
    var el = document.getElementById('kr-' + s);
    if (el) el.classList.add('kr__s--on');
    if (bf) bf.style.width = pcts[s] || '0';
    if (s === '2' && sub2El) {
      sub2El.textContent = state.art === 'lebensmittel'
        ? 'Jeden Schrank oder Regalbereich in der Küche einzeln zählen.'
        : 'Jeden Kleiderschrank oder jede Kommode einzeln zählen.';
    }
    if (s === 'r') calc();
  }

  /* Open/close handlers */
  var helpBtn = document.getElementById('sw-help-btn');
  if (helpBtn) helpBtn.addEventListener('click', function(e) { e.preventDefault(); openKR(); });

  var bg = document.getElementById('kr-bg');
  if (bg) bg.addEventListener('click', closeKR);

  var xBtn = document.getElementById('kr-x');
  if (xBtn) xBtn.addEventListener('click', closeKR);

  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeKR(); });

  /* Option clicks */
  document.querySelectorAll('.kr__opt[data-go]').forEach(function(b) {
    b.addEventListener('click', function() {
      var s = this.dataset.step;
      if (s === '1') state.art = this.dataset.v;
      if (s === '3') state.befall = this.dataset.v;
      goS(this.dataset.go);
    });
  });

  /* Number input (Step 2) */
  var countIn = document.getElementById('kr-count');
  var minusBtn = document.getElementById('kr-minus');
  var plusBtn = document.getElementById('kr-plus');
  var go3Btn = document.getElementById('kr-go3');

  if (minusBtn) minusBtn.addEventListener('click', function() {
    countIn.value = Math.max(1, parseInt(countIn.value, 10) - 1);
  });
  if (plusBtn) plusBtn.addEventListener('click', function() {
    countIn.value = Math.min(30, parseInt(countIn.value, 10) + 1);
  });
  if (go3Btn) go3Btn.addEventListener('click', function() {
    state.stellen = parseInt(countIn.value, 10) || 1;
    goS('3');
  });

  /* === CALCULATION === */
  function calc() {
    var lief = state.art === 'lebensmittel' ? 3 : 6;
    var base = state.befall === 'leicht' ? 1 : state.befall === 'mittel' ? 1.5 : 2;
    var need = Math.max(2, Math.ceil((state.stellen || 1) * base));

    /* cardData pre-computed at init — pure array scan here, no DOM/regex work */
    var best = cardData[cardData.length - 1];
    for (var i = 0; i < cardData.length; i++) {
      if (cardData[i].kp >= need) { best = cardData[i]; break; }
    }
    if (!best) return;

    var total = best.totalExplicit != null ? best.totalExplicit : best.kp * lief;

    /* Price per card */
    var priceClean = best.priceText.replace(/[^\d,]/g, '').replace(',', '.');
    var priceNum = parseFloat(priceClean) || 0;
    var perCard = total > 0 ? (priceNum / total) : 0;
    var perCardStr = perCard.toFixed(2).replace('.', ',') + ' €';

    /* Update result (cached refs) */
    var stellen = state.stellen || 1;
    if (resultRefs.rk) resultRefs.rk.textContent = best.kp + ' Karten';
    if (resultRefs.rd) resultRefs.rd.textContent = '× ' + lief + ' Lieferungen (' + total + ' Karten gesamt)';
    if (resultRefs.rp) resultRefs.rp.textContent = best.priceText;
    if (resultRefs.rpc) resultRefs.rpc.textContent = 'nur ' + perCardStr + ' pro Karte';
    if (resultRefs.rw) resultRefs.rw.textContent = stellen + ' Stelle' +
      (stellen > 1 ? 'n' : '') + ', ' +
      state.befall + 'er Befall → ' + best.kp + ' Karten pro Lieferung empfohlen.';

    state._el = best.el;
  }

  /* Select + close */
  var selBtn = document.getElementById('kr-sel');
  if (selBtn) selBtn.addEventListener('click', function() {
    if (state._el) state._el.click();
    closeKR();
  });

  var rstBtn = document.getElementById('kr-rst');
  if (rstBtn) rstBtn.addEventListener('click', function() { state = {}; goS('1'); });

  /* === "Alle Optionen" Toggle === */
  var toggleBtn = document.getElementById('sw-toggle');
  var list = document.querySelector('.sw__list');
  if (toggleBtn && list) {
    toggleBtn.addEventListener('click', function() {
      var expanded = list.classList.toggle('sw__list--expanded');
      this.classList.toggle('sw__toggle--open', expanded);
      if (expanded) {
        this.innerHTML = 'Weniger anzeigen <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 15 12 9 18 15"/></svg>';
      } else {
        this.innerHTML = 'Alle Optionen <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>';
      }
    });

    /* Auto-expand if active item is hidden (5th+) — reuse cached items NodeList */
    var activeItem = list.querySelector('.sw__item--on');
    if (activeItem) {
      var idx = -1;
      for (var k = 0; k < items.length; k++) { if (items[k] === activeItem) { idx = k; break; } }
      if (idx >= 4) toggleBtn.click();
    }
  }
})();

/* Move audio player: Desktop only = inside product-details after description */
(function(){
  if (window.innerWidth <= 768) return; /* Mobile: leave as-is, no DOM manipulation */

  var audio = document.querySelector('.shopify-section.sk-audio-summary');
  if (!audio) return;

  var desc = document.querySelector('.product-block--description');
  if (desc) {
    desc.parentNode.insertBefore(audio, desc.nextSibling);
    audio.style.margin = '8px 0';
  }
})();
